
import { debounce } from '~/mixins/helpers';

export default {
  name: 'BaseShowMore',
  props: {
    lineCount: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isExpanded: false,
      showButton: false,
      collapsedHeight: 0,
    };
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    checkContentLength() {
      this.$nextTick(() => {
        const element = this.$refs.content;
        if (element) {
          const lineHeight = parseInt(getComputedStyle(element).lineHeight, 10);
          const { lineCount } = this;
          this.collapsedHeight = (lineHeight * lineCount);
          const actualHeight = element.scrollHeight;
          this.showButton = actualHeight > this.collapsedHeight;
        }
      });
    },
    handleResize() {
      this.checkContentLength();
    },
  },
  mounted() {
    this.checkContentLength();
    this.debouncedResizeHandler = debounce(this.handleResize, 300);
    window.addEventListener('resize', this.debouncedResizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedResizeHandler);
  },
};
